import { LogLevel } from "src/app/services/log.service";

export class LogEntry {

  entryDate: Date = new Date();
  level: LogLevel = LogLevel.Debug;
  message: string = "";
  logData: any[] = [];

}
